import React from 'react';
import useModuleConfigTheme from '../../../shared/hooks/useModuleConfigTheme';

/** Tab bar — Products.js / ApprobationsCrudShell pattern (no accordion). */
export function CrmModalFormTabs({ tabs, activeTab, onTabChange, ariaLabel }) {
  const cfgTheme = useModuleConfigTheme();
  const isLight = cfgTheme.light;

  return (
    <div className={`shrink-0 px-6 pt-3 border-b ${isLight ? 'border-gray-200' : 'border-white/10'}`}>
      <div className="flex flex-wrap gap-1" role="tablist" aria-label={ariaLabel}>
        {tabs.map((tab) => {
          const TabIcon = tab.icon;
          const active = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => onTabChange(tab.id)}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-t-xl text-sm font-semibold transition-colors ${
                active
                  ? (isLight
                    ? 'bg-[#6e9b6e]/15 text-forest-900 border-b-2 border-[#6e9b6e] -mb-px'
                    : 'bg-white/10 text-white border-b-2 border-blue-400 -mb-px')
                  : (isLight
                    ? 'text-gray-600 hover:text-gray-900 hover:bg-gray-100/80'
                    : 'text-white/55 hover:text-white hover:bg-white/5')
              }`}
            >
              {TabIcon ? (
                <TabIcon
                  size={16}
                  className={active ? (tab.iconClassName || 'text-blue-400') : ''}
                />
              ) : null}
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

/** Wraps modal form body: negative margin cancels QawaemErpCrudModal padding for flush tabs. */
export function CrmModalFormBody({ children }) {
  return (
    <div className="-m-6 flex flex-col min-h-[280px]">
      {children}
    </div>
  );
}

/** Scrollable tab panel with optional 3-column grid inside. */
export function CrmModalFormPanel({ children, className = '' }) {
  return (
    <div className={`overflow-y-auto p-6 flex-1 min-h-0 ${className}`}>
      {children}
    </div>
  );
}

/** Standard 3-column field grid (Products.js reference). */
export function CrmModalFieldGrid({ children, className = '' }) {
  return (
    <div className={`grid grid-cols-1 md:grid-cols-3 gap-4 ${className}`}>
      {children}
    </div>
  );
}
